/**
 * น้ำหนักและช่องกระเป๋า (GDD หัวข้อ 6 "น้ำหนักกระเป๋า")
 *
 * แบกเกิน 70% ฟื้น HP/MP เองไม่ได้ · เกิน 90% โจมตีไม่ได้
 * server ใช้ตัดสินจริง client ใช้แสดงเตือนก่อนผู้เล่นงงว่าทำไมเลือดไม่ขึ้น
 *
 * pure function ไม่รู้จัก schema ใช้ได้ทั้ง Map, MapSchema และ object ผ่าน `readMap`
 */
import { bagSlots, maxCarryWeight } from "./formulas.js";
/** เกินสัดส่วนนี้ฟื้น HP/MP เองไม่ได้ */
export const HEAVY_RATIO = 0.7;
/** เกินสัดส่วนนี้โจมตีไม่ได้ (ทั้งตีธรรมดาและสกิลโจมตี) */
export const OVERWEIGHT_RATIO = 0.9;
/** น้ำหนักรวมของในกระเป๋า (ของที่สวมใส่อยู่ไม่นับ เหมือนที่หน้าต่างตัวละครโชว์) */
export function bagWeight(items, defs) {
    let sum = 0;
    for (const [id, n] of items)
        if (n > 0)
            sum += (defs[id]?.weight ?? 0) * n;
    return sum;
}
/** ช่องที่ใช้อยู่ = ชนิดของที่มี (ของใช้/วัตถุดิบซ้อนในช่องเดียว ส่วนของสวมใส่แยกช่องละชิ้น) */
export function bagUsedSlots(items, defs) {
    let used = 0;
    for (const [id, n] of items) {
        if (n <= 0)
            continue;
        if (defs && defs[id]?.kind === "equip") {
            used += n;
        }
        else {
            used += 1;
        }
    }
    return used;
}
export function carryState(weight, max) {
    if (max <= 0)
        return "overweight";
    const r = weight / max;
    if (r > OVERWEIGHT_RATIO)
        return "overweight";
    if (r > HEAVY_RATIO)
        return "heavy";
    return "ok";
}
/** ฟื้น HP/MP เองตามเวลาได้ไหม */
export function canRegen(state) {
    return state === "ok";
}
/** โจมตีได้ไหม */
export function canAttack(state) {
    return state !== "overweight";
}
/**
 * รับของเพิ่มได้ไหม (ใช้กับการซื้อจากร้านหรือเก็บของ)
 * เกินน้ำหนักสูงสุด → weight · เป็นของชนิดใหม่หรือของสวมใส่ที่ช่องเต็ม → slots
 *
 * **server ตอนนี้บังคับแค่ weight** (`checkSlots` = false) เพราะของเริ่มต้นกับหินตีบวก
 * ใช้ช่องครบ 12 ตั้งแต่ Lv 1 แล้ว บังคับช่องเมื่อไรผู้เล่นใหม่ซื้อของชนิดใหม่ไม่ได้เลย
 * จะเปิดได้ก็ต่อเมื่อมีคลังเก็บของ หรือปรับจำนวนช่อง/ของเริ่มต้นแล้ว
 */
export function carryDenial(items, defs, str, baseLevel, itemId, count, checkSlots = true, 
/** น้ำหนักของที่ไม่อยู่ใน `items` เช่น ของมีตัวตน (`gearWeight`) */
extraWeight = 0) {
    const list = [...items];
    const add = (defs[itemId]?.weight ?? 0) * count;
    if (bagWeight(list, defs) + extraWeight + add > maxCarryWeight(str))
        return "weight";
    const isNew = !list.some(([id, n]) => id === itemId && n > 0);
    const isEquip = defs[itemId]?.kind === "equip";
    const used = bagUsedSlots(list, defs);
    const addSlots = isEquip ? count : (isNew ? 1 : 0);
    if (checkSlots && (isNew || isEquip) && used + addSlots > bagSlots(baseLevel))
        return "slots";
    return undefined;
}
export const CARRY_TEXT = {
    weight: "กระเป๋าหนักเกินไป แบกเพิ่มไม่ไหว",
    slots: "กระเป๋าเต็ม ไม่มีช่องว่างสำหรับของชนิดใหม่",
    heavy: "กระเป๋าหนัก (เกิน 70%) — HP/MP ไม่ฟื้นเอง",
    overweight: "กระเป๋าหนักเกิน 90% — โจมตีไม่ได้",
};
//# sourceMappingURL=carry.js.map